var $c84b7c3b2102410f$exports = {};
$c84b7c3b2102410f$exports = {
    "actions": `\u{C561}\u{C158}`,
    "hideButtonLabel": `\u{AC04}\u{B7B5}\u{D788} \u{BCF4}\u{AE30}`,
    "noTags": `\u{C5C6}\u{C74C}`,
    "showAllButtonLabel": (args, formatter)=>`\u{BAA8}\u{B450} \u{D45C}\u{C2DC} (${formatter.number(args.tagCount)})`
};


export {$c84b7c3b2102410f$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
